import { Store } from 'store/index';
import { RESULTS_PER_PAGE } from 'settings';
import getOffset from './getOffset';

const getPreviousPageNr = (store: Store) => {
  const familiesOffset = getOffset(store);
  const offsetPageNr = Math.round(familiesOffset / RESULTS_PER_PAGE) + 1;
  return Math.max(offsetPageNr - 1, 1);
};

export default getPreviousPageNr;
